import { ref } from 'vue';
export const useKeyboard = () => {
    let isOpen = ref(false);
    let keyboardHeight = ref(0);
    const showCallback = (ev) => {
        isOpen.value = true;
        keyboardHeight.value = ev.detail.keyboardHeight;
    };
    const hideCallback = () => {
        isOpen.value = false;
        keyboardHeight.value = 0;
    };
    const unregister = () => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('ionKeyboardDidShow', showCallback);
            window.removeEventListener('ionKeyboardDidHide', hideCallback);
        }
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('ionKeyboardDidShow', showCallback);
        window.addEventListener('ionKeyboardDidHide', hideCallback);
    }
    return {
        isOpen,
        keyboardHeight,
        unregister
    };
};
//# sourceMappingURL=keyboard.js.map